/* ==========================================================================
   Tattup Merkliste / Wishlist (2026-10-19) – own replacement for the Swym app.

   Guests: the list lives on this device (localStorage), no network call at all.
   Logged-in customers (phase 2, 2026-10-19): the list is also saved in the customer account
   through the Shopify App Proxy /apps/tattup-own?f=wishlist (backend: Vercel project
   tattup-own-apps, api/proxy.js + lib/wishlist.js). Shopify signs every proxy request and adds
   the logged-in customer id, so the browser never sends an id of its own.
     State = { items: [{ h: handle, v: variant id|null, t: saved at (ms) }], del: [{ h, t: removed at }] }
     Merge = per handle the newest event (saved / removed) wins - same rules as lib/wishlist.js,
     so device + account lists combine without duplicates, nothing gets lost and a removal on
     one device also removes the tattoo on the others.
   First page view after a login: the device list is merged into the account list (only the
   tattoos added as guest when the device was last synced for another customer).
   Afterwards: GET at most once a minute (and when the tab comes back), PUT ~0.7 s after a change.
   Offline / slow / proxy missing: everything keeps working on the device list, the change is
   sent with the next sync.

   Markup hooks (rendered by Liquid):
     .tt-wl-heart[data-wl-handle][data-wl-variant]  heart toggle (cards, product page)
     [data-wl-open]                                  opens the drawer (header hearts)
     [data-wl-count]                                 count badge (empty = hidden)
   Share link: any page with ?wl=handle1,handle2 opens the drawer with those tattoos.
   Speed: no polling, product data (/products/<handle>.js) is fetched only when the
   drawer opens, the drawer CSS + markup are created on first open.
   ========================================================================== */
(function () {
  'use strict';
  if (window.TattupWishlist) return;

  var CFG = window.ttWlConfig || {};
  var S = CFG.s || {};
  var KEY = 'tt_wishlist_v1';
  var MAX = 200;                    // same limits as the backend
  var MAX_DEL = 300;
  var DEL_KEEP = 180 * 864e5;
  var ROOT = String(CFG.root || '/').replace(/\/?$/, '/');
  var HANDLE_RE = /^[^\s\/?#&,<>"'\\]{1,255}$/;
  // account sync: switched on in snippets/tt-wishlist-boot.liquid (proxy path + customer id from Liquid)
  var SYNC_ON = !!(CFG.accountSync && CFG.proxy);
  var ACCOUNT = !!(SYNC_ON && CFG.customer && /^\d{1,20}$/.test(String(CFG.cid || '')));
  var CID = ACCOUNT ? String(CFG.cid) : '';

  /* ---------- storage ---------- */
  var memory = { items: [], del: [], acct: null, dirty: false };
  function readState() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var data = raw ? JSON.parse(raw) : null;
      if (!data) return { items: [], del: [], acct: null, dirty: false };
      var acct = data.acct && /^\d{1,20}$/.test(String(data.acct.id)) ? { id: String(data.acct.id), at: Number(data.acct.at) || 0 } : null;
      var m = mergeState({ items: clean(data.items), del: cleanDel(data.del) }, null);
      return { items: m.items, del: m.del, acct: acct, dirty: !!data.dirty };
    } catch (e) {
      return { items: memory.items.slice(), del: memory.del.slice(), acct: memory.acct, dirty: memory.dirty };
    }
  }
  function writeLocal() {
    memory = { items: items.slice(), del: dels.slice(), acct: acct, dirty: dirty };
    try { window.localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items, del: dels, acct: acct, dirty: dirty || undefined })); } catch (e) {}
  }
  function clean(list) {
    var seen = {};
    var out = [];
    (Array.isArray(list) ? list : []).forEach(function (it) {
      if (!it || typeof it.h !== 'string' || !HANDLE_RE.test(it.h)) return;
      var item = { h: it.h, v: Number(it.v) > 0 ? Number(it.v) : null, t: Number(it.t) > 0 ? Number(it.t) : Date.now() };
      if (seen[item.h]) {
        if (item.t > seen[item.h].t) { seen[item.h].v = item.v; seen[item.h].t = item.t; }
        return;
      }
      seen[item.h] = item;
      out.push(item);
    });
    out.sort(function (a, b) { return b.t - a.t; });
    return out.slice(0, MAX);
  }
  function cleanDel(list) {
    return (Array.isArray(list) ? list : []).filter(function (d) {
      return d && typeof d.h === 'string' && HANDLE_RE.test(d.h) && Number(d.t) > 0;
    }).map(function (d) { return { h: d.h, t: Number(d.t) }; });
  }
  // "last write wins" per handle - keep in step with lib/wishlist.js merge() in tattup-own-apps
  function mergeState(a, b) {
    var add = {}, rem = {}, now = Date.now();
    [a, b].forEach(function (s) {
      if (!s) return;
      (s.items || []).forEach(function (it) {
        var c = add[it.h];
        if (!c || it.t > c.t || (it.t === c.t && (it.v || 0) > (c.v || 0))) add[it.h] = { h: it.h, v: it.v || null, t: it.t };
      });
      (s.del || []).forEach(function (d) {
        var c = rem[d.h];
        if (!c || d.t > c.t) rem[d.h] = { h: d.h, t: d.t };
      });
    });
    var outItems = [], outDel = [];
    Object.keys(add).forEach(function (h) {
      if (!rem[h] || add[h].t >= rem[h].t) { outItems.push(add[h]); delete rem[h]; }
    });
    Object.keys(rem).forEach(function (h) { if (now - rem[h].t < DEL_KEEP) outDel.push(rem[h]); });
    var byT = function (x, y) { return y.t - x.t || (x.h < y.h ? -1 : 1); };
    outItems.sort(byT);
    outDel.sort(byT);
    return { items: outItems.slice(0, MAX), del: outDel.slice(0, MAX_DEL) };
  }
  function sameState(a, b) {
    var key = function (s) { return JSON.stringify([s.items.map(function (i) { return [i.h, i.v || 0]; }), s.del.map(function (d) { return d.h; })]); };
    return key(a) === key(b);
  }

  var boot = readState();
  var items = boot.items;
  var dels = boot.del;
  var acct = boot.acct;            // { id: customer id, at: last successful sync } of this device
  var dirty = boot.dirty;          // a change has not reached the account yet

  function indexOf(handle) {
    for (var i = 0; i < items.length; i++) if (items[i].h === handle) return i;
    return -1;
  }
  function has(handle) { return indexOf(handle) > -1; }

  function commit() {
    if (ACCOUNT) dirty = true;
    writeLocal();
    syncUI();
    emit('change');
    if (ACCOUNT) schedulePush();
  }
  function add(handle, variant, silent) {
    if (!HANDLE_RE.test(handle || '')) return false;
    var i = indexOf(handle);
    var v = Number(variant) > 0 ? Number(variant) : null;
    if (i > -1) { if (v) items[i].v = v; }
    else items.unshift({ h: handle, v: v, t: Date.now() });
    items = clean(items);
    dels = dels.filter(function (d) { return d.h !== handle; });
    commit();
    if (!silent) toast(S.saved, true);
    return true;
  }
  function remove(handle, silent) {
    var i = indexOf(handle);
    if (i < 0) return;
    items.splice(i, 1);
    dels = [{ h: handle, t: Date.now() }].concat(dels.filter(function (d) { return d.h !== handle; })).slice(0, MAX_DEL);
    commit();
    if (!silent) toast(S.removed, false);
  }
  function emit(name) {
    document.dispatchEvent(new CustomEvent('tt-wishlist:' + name, { detail: { items: items.slice() } }));
  }

  /* ---------- hearts + count ---------- */
  function paintHeart(btn) {
    var on = has(btn.getAttribute('data-wl-handle'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? (S.remove || 'Remove') : (S.add || 'Save'));
    btn.setAttribute('data-wl-ready', '');
  }
  function syncUI() {
    document.querySelectorAll('.tt-wl-heart[data-wl-handle]').forEach(paintHeart);
    var n = items.length;
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.hidden = n === 0;
    });
    if (drawer && drawer.hasAttribute('open') && mode === 'own') renderDrawer();
  }

  // hearts that arrive later (filters, recommendations, infinite scroll)
  var pending = false;
  function paintNew() {
    pending = false;
    document.querySelectorAll('.tt-wl-heart[data-wl-handle]:not([data-wl-ready])').forEach(paintHeart);
  }
  // perf 2026-10-26: the observer starts after the load event (apps and pixels change the DOM hundreds of times
  // while the page loads) and repaints at most every 150 ms; hearts present at boot are painted by syncUI().
  function watchNew() {
    if (!window.MutationObserver) return;
    paintNew();
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(paintNew, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'complete') watchNew();
  else {
    // hearts rendered by scripts before load (e.g. recommendations) still get painted
    document.addEventListener('DOMContentLoaded', paintNew, { once: true });
    window.addEventListener('load', watchNew, { once: true });
  }

  function bump(btn) {
    btn.classList.remove('is-bump');
    void btn.offsetWidth;
    btn.classList.add('is-bump');
  }

  document.addEventListener('click', function (evt) {
    var heart = evt.target.closest && evt.target.closest('.tt-wl-heart[data-wl-handle]');
    if (heart) {
      evt.preventDefault();
      evt.stopPropagation();
      var handle = heart.getAttribute('data-wl-handle');
      if (has(handle)) remove(handle);
      else { add(handle, heart.getAttribute('data-wl-variant')); bump(heart); }
      return;
    }
    var opener = evt.target.closest && evt.target.closest('[data-wl-open]');
    if (opener) {
      evt.preventDefault();
      open(opener);
    }
  }, true);

  // another tab changed the list
  window.addEventListener('storage', function (evt) {
    if (evt.key !== KEY) return;
    var st = readState();
    items = st.items; dels = st.del; acct = st.acct; dirty = st.dirty;
    syncUI();
  });

  /* ---------- toast ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(text, withView) {
    if (!text) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tt-wl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML = '<svg class="tt-wl-toast__i" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#tt-wl-i"/></svg><span class="tt-wl-toast__t"></span><button type="button" class="tt-wl-toast__b" data-wl-open></button>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('.tt-wl-toast__t').textContent = text;
    var b = toastEl.querySelector('.tt-wl-toast__b');
    b.textContent = S.view || '';
    b.hidden = !withView || (drawer && drawer.hasAttribute('open'));
    toastEl.classList.toggle('is-on-list', !!withView);
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2400);
  }

  /* ---------- money ---------- */
  // CFG.money is 1234.56 formatted by Liquid's money filter for the visitor's currency.
  var moneyFmt = (function () {
    var sample = String(CFG.money || '');
    var m = sample.match(/1(\D?)234(?:(\D)56)?/);
    if (!m) return null;
    return { pre: sample.slice(0, m.index), post: sample.slice(m.index + m[0].length), th: m[1] || '', dec: m[2] || '', decimals: !!m[2] };
  })();
  function money(cents) {
    var n = Number(cents) / 100;
    if (!moneyFmt) return n.toFixed(2);
    var parts = n.toFixed(moneyFmt.decimals ? 2 : 0).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyFmt.th);
    return moneyFmt.pre + int + (moneyFmt.decimals ? moneyFmt.dec + parts[1] : '') + moneyFmt.post;
  }

  /* ---------- product data (only while the drawer is open) ---------- */
  var cache = {};
  var CACHE_MS = 5 * 60 * 1000;
  function fresh(handle) {
    var c = cache[handle];
    return c && Date.now() - c.at < CACHE_MS ? c : null;
  }
  function getProduct(handle) {
    var c = fresh(handle);
    if (c) return c.p;
    var entry = { at: Date.now(), done: false, data: null };
    entry.p = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (data) { entry.done = true; entry.data = data; return data; });
    cache[handle] = entry;
    return entry.p;
  }
  function pickVariant(product, wantedId) {
    if (!product || !product.variants) return null;
    var vs = product.variants;
    for (var i = 0; i < vs.length; i++) if (vs[i].id === wantedId && vs[i].available) return vs[i];
    for (var j = 0; j < vs.length; j++) if (vs[j].available) return vs[j];
    return null;
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- cart (same flow as the card quick-add in custom.js) ---------- */
  function cartAdd(lines) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && (data.description || data.message)) || 'error');
        return data;
      });
    });
  }
  function afterCartAdd() {
    // header/drawer/reward bar/free-tattoo logic all listen to on:cart:change
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.cart-link__count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
        });
      })
      .catch(function () {});
    close();
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
    }, 60);
  }

  /* ---------- drawer ---------- */
  var drawer = null;
  var mode = 'own';          // 'own' | 'shared'
  var sharedList = [];
  var cssPromise = null;
  var renderToken = 0;

  function loadCss() {
    if (cssPromise) return cssPromise;
    cssPromise = new Promise(function (resolve) {
      if (!CFG.css) return resolve();
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = CFG.css;
      link.onload = resolve;
      link.onerror = resolve;
      document.head.appendChild(link);
      setTimeout(resolve, 2500);
    });
    return cssPromise;
  }

  var ICON_X = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_SHARE = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 3v12M7 8l5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#tt-wl-i"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function buildDrawer() {
    var Base = (window.customElements && window.customElements.get('side-drawer')) || null;
    if (window.customElements && !window.customElements.get('wishlist-drawer')) {
      var Cls = Base ? class extends Base {} : class extends HTMLElement {};
      window.customElements.define('wishlist-drawer', Cls);
    }
    var el = document.createElement('wishlist-drawer');
    el.className = 'drawer tt-wl-drawer has-motion';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'TtWlTitle');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
    el.setAttribute('data-name', 'wishlist-drawer');
    el.innerHTML =
      '<div class="tt-wl__head">' +
        '<h2 class="tt-wl__title" id="TtWlTitle"><span class="tt-wl__title-t"></span> <span class="tt-wl__title-n"></span></h2>' +
        '<button type="button" class="tt-wl__close" data-wl-close aria-label="' + esc(S.close) + '">' + ICON_X + '</button>' +
      '</div>' +
      '<p class="tt-wl__note" hidden></p>' +
      '<div class="tt-wl__body" aria-busy="false"><ul class="tt-wl__list" role="list"></ul><div class="tt-wl__empty" hidden></div></div>' +
      '<div class="tt-wl__foot" hidden>' +
        '<p class="tt-wl__msg" role="alert" hidden></p>' +
        '<button type="button" class="tt-wl__btn tt-wl__btn--all" data-wl-all></button>' +
        '<button type="button" class="tt-wl__btn tt-wl__btn--ghost" data-wl-saveall hidden></button>' +
        '<div class="tt-wl__save" hidden><a class="tt-wl__btn tt-wl__btn--ghost" data-wl-login href="#"></a><p class="tt-wl__login"></p></div>' +
        '<button type="button" class="tt-wl__btn tt-wl__btn--ghost tt-wl__share" data-wl-share>' + ICON_SHARE + '<span></span></button>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', onDrawerClick);
    if (!Base) {
      // minimal fallback when the theme drawer class is missing
      el.open = function () { el.setAttribute('open', ''); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('tt-wl-lock'); el.focus(); };
      el.close = function () { leaveShared(); el.removeAttribute('open'); el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('tt-wl-lock'); };
    }
    el.addEventListener('on:wishlist-drawer:before-close', leaveShared);
    return el;
  }
  function leaveShared() {
    if (mode === 'shared') { mode = 'own'; stripShareParam(); }
  }
  // ESC closes even when focus is outside the drawer (e.g. taken by a chat widget)
  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && drawer && drawer.hasAttribute('open')) close();
  });

  function open(opener, shared) {
    // header heart / toast always show the own list; only the ?wl= share link opens the shared view
    if (shared) { mode = 'shared'; sharedList = shared; } else { leaveShared(); }
    if (toastEl) toastEl.classList.remove('is-visible');
    return loadCss().then(function () {
      if (!drawer) drawer = buildDrawer();
      renderDrawer();
      if (!drawer.hasAttribute('open')) {
        var focusEl = drawer.querySelector('[data-wl-close]');
        drawer.open(opener && opener.focus ? opener : null, focusEl);
      }
    });
  }
  function close() {
    if (drawer && drawer.hasAttribute('open')) drawer.close();
  }

  function listForMode() {
    if (mode === 'shared') return sharedList.map(function (h) { return { h: h, v: null, t: 0 }; });
    return items.slice();
  }

  function renderDrawer() {
    if (!drawer) return;
    var list = listForMode();
    var token = ++renderToken;
    var titleT = drawer.querySelector('.tt-wl__title-t');
    var titleN = drawer.querySelector('.tt-wl__title-n');
    var note = drawer.querySelector('.tt-wl__note');
    var ul = drawer.querySelector('.tt-wl__list');
    var empty = drawer.querySelector('.tt-wl__empty');
    var foot = drawer.querySelector('.tt-wl__foot');
    var body = drawer.querySelector('.tt-wl__body');

    titleT.textContent = mode === 'shared' ? (S.shared_title || S.title) : S.title;
    titleN.textContent = list.length ? '(' + list.length + ')' : '';

    // shared note / "saved in your account" (only after the account answered)
    var isAccount = mode === 'own' && ACCOUNT && syncOk;
    note.classList.toggle('is-account', isAccount);
    if (mode === 'shared') note.textContent = S.shared_note || '';
    else if (isAccount) note.innerHTML = ICON_CHECK + '<span>' + esc(S.account_saved || '') + '</span>';
    else note.textContent = '';
    note.hidden = !(mode === 'shared' ? S.shared_note : isAccount && S.account_saved);

    hideMsg();

    if (!list.length) {
      ul.innerHTML = '';
      ul.hidden = true;
      foot.hidden = true;
      empty.hidden = false;
      empty.innerHTML =
        '<span class="tt-wl__empty-i">' + ICON_HEART + '</span>' +
        '<p class="tt-wl__empty-h">' + esc(S.empty_heading) + '</p>' +
        '<p class="tt-wl__empty-p">' + esc(S.empty_text) + '</p>' +
        '<a class="tt-wl__btn tt-wl__btn--cta" href="' + esc(CFG.all || ROOT) + '"><span>' + esc(S.empty_button) + '</span>' + ICON_ARROW + '</a>' +
        loginHint();
      return refreshTrap();
    }

    empty.hidden = true;
    empty.innerHTML = '';
    ul.hidden = false;
    foot.hidden = false;

    var allBtn = drawer.querySelector('[data-wl-all]');
    var saveAllBtn = drawer.querySelector('[data-wl-saveall]');
    var shareBtn = drawer.querySelector('[data-wl-share]');
    allBtn.textContent = S.pack_all || '';
    allBtn.disabled = true;
    saveAllBtn.textContent = S.save_all || '';
    saveAllBtn.hidden = mode !== 'shared';
    saveAllBtn.disabled = true;
    shareBtn.hidden = mode === 'shared';
    shareBtn.querySelector('span').textContent = S.share || '';
    // guests: "Merkliste speichern" -> login, back to this page afterwards
    var save = drawer.querySelector('.tt-wl__save');
    var showSave = mode === 'own' && guestCanLogin();
    save.hidden = !showSave;
    if (showSave) {
      var sb = save.querySelector('[data-wl-login]');
      sb.textContent = S.save_account || '';
      sb.setAttribute('href', loginUrl());
      save.querySelector('.tt-wl__login').textContent = S.login_hint || '';
    }

    function paint(products) {
      var available = 0;
      ul.innerHTML = list.map(function (it, i) {
        var p = products[i];
        var v = pickVariant(p, it.v);
        if (v) available++;
        return rowHtml(it, p, v);
      }).join('');
      body.setAttribute('aria-busy', 'false');
      allBtn.disabled = available === 0;
      saveAllBtn.disabled = false;
      refreshTrap();
    }

    // already fetched (e.g. after a remove): paint at once, no flicker
    var known = list.every(function (it) { var c = fresh(it.h); return c && c.done; });
    if (known) return paint(list.map(function (it) { return cache[it.h].data; }));

    // skeleton rows right away, real data as soon as it arrives
    ul.innerHTML = list.map(function (it) {
      return '<li class="tt-wl-item is-loading" data-h="' + esc(it.h) + '"><span class="tt-wl-item__img"></span><span class="tt-wl-item__info"><span class="tt-wl-item__sk"></span><span class="tt-wl-item__sk tt-wl-item__sk--s"></span></span></li>';
    }).join('');
    body.setAttribute('aria-busy', 'true');
    Promise.all(list.map(function (it) { return getProduct(it.h); })).then(function (products) {
      if (token !== renderToken) return;
      paint(products);
    });
    refreshTrap();
  }

  function rowHtml(it, p, v) {
    var url = ROOT + 'products/' + encodeURIComponent(it.h);
    var title = p ? p.title : it.h.replace(/-/g, ' ');
    var img = p && (p.featured_image || (p.images && p.images[0]));
    var soldOut = !v;
    var priceHtml = '';
    if (!soldOut) {
      priceHtml = '<span class="tt-wl-item__price">' + esc(money(v.price)) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) priceHtml += ' <s class="tt-wl-item__was">' + esc(money(v.compare_at_price)) + '</s>';
    } else {
      priceHtml = '<span class="tt-wl-item__sold">' + esc(S.sold_out) + '</span>';
    }
    var variantLine = '';
    if (v && p && p.variants && p.variants.length > 1 && v.title && v.title !== 'Default Title') {
      variantLine = '<span class="tt-wl-item__v">' + esc(v.title) + '</span>';
    }
    var sideBtn = mode === 'shared' && !p
      ? '<span></span>'
      : mode === 'shared'
      ? '<button type="button" class="tt-wl-heart tt-wl-heart--row" data-wl-handle="' + esc(it.h) + '" data-wl-variant="' + (v ? v.id : '') + '" aria-pressed="' + (has(it.h) ? 'true' : 'false') + '" aria-label="' + esc(has(it.h) ? S.remove : S.add) + '" data-wl-ready>' + ICON_HEART + '</button>'
      : '<button type="button" class="tt-wl-item__x" data-wl-remove="' + esc(it.h) + '" aria-label="' + esc((S.remove || '') + ': ' + title) + '">' + ICON_X + '</button>';
    return '<li class="tt-wl-item' + (soldOut ? ' is-soldout' : '') + '" data-h="' + esc(it.h) + '">' +
      '<a class="tt-wl-item__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(imgUrl(img, 200)) + '" alt="" width="100" height="125" loading="lazy" decoding="async">' : '') +
      '</a>' +
      '<div class="tt-wl-item__info">' +
        '<a class="tt-wl-item__t" href="' + esc(url) + '">' + esc(title) + '</a>' +
        variantLine +
        '<span class="tt-wl-item__p">' + priceHtml + '</span>' +
        (soldOut ? '' : '<button type="button" class="tt-wl-item__pack" data-wl-pack="' + v.id + '">' + esc(S.pack) + '</button>') +
      '</div>' + sideBtn +
    '</li>';
  }

  function guestCanLogin() { return SYNC_ON && !CFG.customer && !!CFG.login && !!S.login_hint; }
  // new customer accounts: /customer_authentication/login?return_to=<this page>&locale=<de|en>
  function loginUrl() {
    var back = '/';
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('wl');
      u.searchParams.set('wl_open', '1');
      back = u.pathname + u.search;
    } catch (e) {}
    return CFG.login + (CFG.login.indexOf('?') > -1 ? '&' : '?') + 'return_to=' + encodeURIComponent(back) + (CFG.locale ? '&locale=' + encodeURIComponent(CFG.locale) : '');
  }
  function loginHint() {
    if (!guestCanLogin()) return '';
    return '<p class="tt-wl__login"><a href="' + esc(loginUrl()) + '">' + esc(S.login_hint) + '</a></p>';
  }

  function refreshTrap() {
    if (!drawer || !drawer.hasAttribute('open') || typeof window.trapFocus !== 'function') return;
    var active = drawer.contains(document.activeElement) ? document.activeElement : drawer.querySelector('[data-wl-close]');
    try { window.trapFocus(drawer, active); } catch (e) {}
  }

  function showMsg(text) {
    var m = drawer && drawer.querySelector('.tt-wl__msg');
    if (!m) return;
    m.textContent = text;
    m.hidden = false;
  }
  function hideMsg() {
    var m = drawer && drawer.querySelector('.tt-wl__msg');
    if (m) { m.hidden = true; m.textContent = ''; }
  }

  function onDrawerClick(evt) {
    var t = evt.target;
    if (t.closest('[data-wl-close]')) { evt.preventDefault(); close(); return; }

    var rm = t.closest('[data-wl-remove]');
    if (rm) {
      var h = rm.getAttribute('data-wl-remove');
      var li = rm.closest('.tt-wl-item');
      var next = li && (li.nextElementSibling || li.previousElementSibling);
      var nextH = next && next.getAttribute('data-h');
      remove(h, true);
      // keep keyboard focus inside the list
      var target = nextH && drawer.querySelector('.tt-wl-item[data-h="' + cssEsc(nextH) + '"] [data-wl-remove]');
      (target || drawer.querySelector('[data-wl-close]')).focus();
      return;
    }

    var pack = t.closest('[data-wl-pack]');
    if (pack) {
      if (pack.classList.contains('is-loading')) return;
      pack.classList.add('is-loading');
      hideMsg();
      cartAdd([{ id: Number(pack.getAttribute('data-wl-pack')), quantity: 1 }])
        .then(function () { pack.classList.remove('is-loading'); afterCartAdd(); })
        .catch(function (e) { pack.classList.remove('is-loading'); showMsg(e && e.message && e.message !== 'error' ? e.message : S.error); });
      return;
    }

    var all = t.closest('[data-wl-all]');
    if (all) {
      var lines = [];
      drawer.querySelectorAll('[data-wl-pack]').forEach(function (b) { lines.push({ id: Number(b.getAttribute('data-wl-pack')), quantity: 1 }); });
      if (!lines.length || all.classList.contains('is-loading')) return;
      all.classList.add('is-loading');
      hideMsg();
      cartAdd(lines)
        .catch(function () {
          // one line refused (e.g. sold out a second ago) – add the others one by one
          var ok = 0;
          return lines.reduce(function (chain, line) {
            return chain.then(function () { return cartAdd([line]).then(function () { ok++; }, function () {}); });
          }, Promise.resolve()).then(function () { if (!ok) throw new Error('error'); });
        })
        .then(function () { all.classList.remove('is-loading'); afterCartAdd(); })
        .catch(function () { all.classList.remove('is-loading'); showMsg(S.error); });
      return;
    }

    var saveAll = t.closest('[data-wl-saveall]');
    if (saveAll) {
      sharedList.slice().reverse().forEach(function (h) {
        var btn = drawer.querySelector('.tt-wl-heart[data-wl-handle="' + cssEsc(h) + '"]');
        if (!btn) return; // product no longer exists
        if (!has(h)) add(h, btn.getAttribute('data-wl-variant'), true);
      });
      toast(S.saved, false);
      return;
    }

    var share = t.closest('[data-wl-share]');
    if (share) { copyShareLink(share); }
  }

  function cssEsc(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'); }

  /* ---------- share ---------- */
  function shareUrl() {
    return window.location.origin + ROOT + '?wl=' + items.map(function (it) { return encodeURIComponent(it.h); }).join(',');
  }
  function copyShareLink(btn) {
    var url = shareUrl();
    var label = btn.querySelector('span');
    var done = function () {
      label.textContent = S.share_copied || '';
      btn.classList.add('is-done');
      setTimeout(function () { label.textContent = S.share || ''; btn.classList.remove('is-done'); }, 2200);
    };
    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
      drawer.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      drawer.removeChild(ta);
      btn.focus();
      done();
    };
    var copy = function () {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, fallback);
      else fallback();
    };
    // phones and tablets: the device's own share menu (WhatsApp, Instagram, SMS …); computers: copy the link
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (touch && navigator.share) {
      navigator.share({ title: S.share_title || '', text: S.share_text || '', url: url })
        .catch(function (e) { if (!e || e.name !== 'AbortError') copy(); });
      return;
    }
    copy();
  }
  function readShareParam() {
    try {
      var raw = new URLSearchParams(window.location.search).get('wl');
      if (!raw) return null;
      var seen = {};
      return raw.split(',').map(function (h) { return decodeURIComponent(h).trim(); }).filter(function (h) {
        if (!HANDLE_RE.test(h) || seen[h]) return false;
        seen[h] = true;
        return true;
      }).slice(0, 50);
    } catch (e) { return null; }
  }
  function stripShareParam() {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('wl')) return;
      u.searchParams.delete('wl');
      window.history.replaceState(window.history.state, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
  }

  /* ---------- account sync (logged-in customers only, never for guests) ---------- */
  var SS_KEY = 'tt_wl_sync';
  var FRESH_MS = 60 * 1000;      // at most one GET per minute while browsing
  var syncOk = false;            // the account answered on this page -> "saved in your account"
  var getting = null;
  var pushing = false, pushAgain = false, pushChain = 0, pushTimer = null;

  // last sync of this tab session: { id, at, fail } - a failed sync also waits a minute before the next try
  function sessionFresh() {
    try {
      var d = JSON.parse(window.sessionStorage.getItem(SS_KEY) || 'null');
      return d && d.id === CID && Date.now() - d.at < FRESH_MS ? d : null;
    } catch (e) { return null; }
  }
  function markSession(fail) {
    try { window.sessionStorage.setItem(SS_KEY, JSON.stringify({ id: CID, at: Date.now(), fail: fail ? 1 : 0 })); } catch (e) {}
  }

  function request(method, body, keepalive) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl && !keepalive ? setTimeout(function () { ctl.abort(); }, 8000) : null;
    var opts = { method: method, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    if (ctl) opts.signal = ctl.signal;
    if (keepalive) opts.keepalive = true;
    return fetch(CFG.proxy, opts).then(function (r) {
      var ct = r.headers.get('content-type') || '';
      if (!r.ok || ct.indexOf('json') < 0) throw new Error('sync ' + r.status);
      return r.json();
    }).then(function (d) {
      if (timer) clearTimeout(timer);
      if (!d || !d.ok) throw new Error('sync');
      return { items: clean(d.items), del: cleanDel(d.del) };
    }, function (e) {
      if (timer) clearTimeout(timer);
      throw e;
    });
  }

  function adopt(state, isDirty) {
    var changed = !sameState(state, { items: items, del: dels });
    items = state.items;
    dels = state.del;
    acct = { id: CID, at: Date.now() };
    dirty = !!isDirty;
    writeLocal();
    syncUI();
    if (changed) emit('change');
  }

  // GET the account list and merge it with the device list (first view after a login: merge in the guest list)
  function pull(force) {
    if (!ACCOUNT) return Promise.resolve();
    if (getting) return getting;
    var fresh = !force && sessionFresh();
    if (fresh && fresh.fail) { syncOk = false; return Promise.resolve(); }
    if (fresh && !dirty && acct && acct.id === CID) { syncOk = true; return Promise.resolve(); }
    getting = request('GET').then(function (remote) {
      var local;
      if (acct && acct.id === CID) local = { items: items, del: dels };
      else if (acct && acct.id) {
        // the device was last synced for another customer: only take what was added as guest since then
        var since = acct.at;
        local = { items: items.filter(function (it) { return it.t > since; }), del: [] };
      } else local = { items: items, del: [] };
      var merged = mergeState(local, remote);
      var same = sameState(merged, remote);
      adopt(merged, !same);
      if (same) { syncOk = true; markSession(); }
      else { pushChain = 0; push(); }
    }).catch(function () {
      // offline, slow or proxy not set up yet: everything keeps working on the device list
      syncOk = false;
      markSession(true);
    }).then(function () {
      getting = null;
      syncUI();
    });
    return getting;
  }

  function schedulePush() {
    if (!ACCOUNT) return;
    if (!acct || acct.id !== CID) { pull(true); return; } // first merge not done yet: the GET merges and saves
    clearTimeout(pushTimer);
    pushChain = 0;
    pushTimer = setTimeout(push, 700);
  }
  function push() {
    clearTimeout(pushTimer);
    if (pushing) { pushAgain = true; return; }
    pushing = true;
    request('PUT', { items: items.slice(), del: dels.slice() }).then(function (res) {
      // the answer already contains every device's changes; keep what changed here meanwhile
      var merged = mergeState({ items: items, del: dels }, res);
      var same = sameState(merged, res);
      adopt(merged, !same);
      if (same) { syncOk = true; markSession(); }
      else if (pushChain++ < 2) pushAgain = true;
    }).catch(function () {
      syncOk = false; // stays dirty, sent again with the next sync
    }).then(function () {
      pushing = false;
      syncUI();
      if (pushAgain) { pushAgain = false; pushTimer = setTimeout(push, 700); }
    });
  }

  if (ACCOUNT) {
    // changes made right before leaving the page
    window.addEventListener('pagehide', function () {
      if (!dirty || pushing || !acct || acct.id !== CID) return;
      try { request('PUT', { items: items, del: dels }, true).catch(function () {}); } catch (e) {}
    });
    // back to the tab (e.g. after saving on the phone): refresh, at most once a minute
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') pull(false);
    });
  }

  function readOpenParam() {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('wl_open')) return false;
      u.searchParams.delete('wl_open');
      window.history.replaceState(window.history.state, '', u.pathname + (u.search || '') + u.hash);
      return true;
    } catch (e) { return false; }
  }

  window.TattupWishlist = {
    items: function () { return items.slice(); },
    has: has,
    add: function (h, v) { return add(h, v, true); },
    remove: function (h) { remove(h, true); },
    open: function () { return open(null); },
    close: close,
    sync: function () { return pull(true); },
    synced: function () { return syncOk; },
    merge: mergeState
  };

  /* ---------- boot ---------- */
  syncUI();
  var shared = readShareParam();
  var backFromLogin = readOpenParam();
  if (shared && shared.length) open(null, shared);
  else if (backFromLogin && ACCOUNT) open(null);
  if (ACCOUNT) {
    // first view after a login (or a pending change): right away, so the count is right; otherwise when idle
    if (!acct || acct.id !== CID || dirty || backFromLogin) pull(backFromLogin);
    else (window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); })(function () { pull(false); }, { timeout: 2500 });
  }
  emit('ready');
})();
